/**
 * Created by Andrey Popov on 10.11.2021
 */

const BundlesExplorerView = AnalyzerWindowBase.extend({
    ctor: function (bundlesExplorer) {
        this._super(["Main", "Episodes", "Debug"]);

        this.bundlesExplorer = bundlesExplorer;
        this.itemViews = [];

        this.bundlesExplorer.on("selectionChanged", this.selectItem.bind(this), this);
        this.bundlesExplorer.on("selectedTabChanged", this.selectedTabChanged.bind(this), this);
        this.bundlesExplorer.on("rebuildItems", this.rebuildItems.bind(this), this);

        this.addKeyboardNavigation();

        this.onResize();
        this.addSpotlight();
    },

    addSpotlight: function () {
        const filterBox = new FilterBox(this.bundlesExplorer);
        filterBox.setAlignment(cleverapps.styles.BundlesExplorerView.filterBox);
        this.addChild(filterBox);
    },

    onResize: function () {
        const sceneSize = cleverapps.resolution.getSceneSize();

        const width = cleverapps.styles.BundlesExplorerView.width;
        const height = sceneSize.height - cleverapps.styles.AtlasAnalyzerScene.offsetTop;

        this.setContentSize(width, height);
        this._super();
    },

    rebuildItems: function () {
        const styles = cleverapps.styles.BundlesExplorerView;

        this.itemViews = [];
        const itemViews = this.bundlesExplorer.items.map((explorerItem) => {
            const itemView = new ExplorerItemView(explorerItem, this.bundlesExplorer.loadedBundles.indexOf(explorerItem) !== -1);
            this.itemViews.push(itemView);
            return itemView;
        });

        this.createScroll(new cleverapps.Layout(itemViews, {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        }));

        this.scroll.scrollToPercent(100);
    },

    selectItem: function (tab, texture) {
        this.itemViews.forEach((itemView) => {
            itemView.setSelected(itemView.explorerItem === texture);
        });
    },

    selectedTabChanged: function (tab) {
        this.onTabClick(tab, true);
    },

    onTabClick: function (tab, fromModel) {
        this._super(tab);
        if (fromModel !== true) {
            this.bundlesExplorer.onTabChanged(tab);
        }
    },

    addKeyboardNavigation: function () {
        cleverapps.inputDispatcher.on("keypressed", function (key) {
            if (key === InputDispatcher.KEY.up) {
                this.bundlesExplorer.moveUp();
            } else if (key === InputDispatcher.KEY.down) {
                this.bundlesExplorer.moveDown();
            }
        }.bind(this), this);
    }
});

cleverapps.styles.BundlesExplorerView = {
    margin: 6,
    width: 400,

    filterBox: {
        x: { align: "left", dx: 10 },
        y: { align: "top", dy: 70 }
    }
};